@if (facade.isMultiSavingsPlanOrder$ | async) {
  <div class="row mb-4">
    <div class="col text-right">
      <div>{{ 'savings-plan.add-savings-plan.sum' | transloco }}</div>
      <div data-zid="estimated-sum-strategie" class="estimated-sum">
        @if (facade.multiSavingsPlanSum$ | async; as sum) {
          {{ sum | currency }}
        } @else {
          &dash;
        }
      </div>
    </div>
  </div>
}
